export default __webpack_public_path__ + "static/media/home_logo.0e832d47.svg";